import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">{aboutData.title}</h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
                {aboutData.intro}
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {aboutData.description}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                  <div className="font-heading font-black text-2xl md:text-3xl text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}